import React from 'react'
import { Tab, TabProps } from './Tab'

const TabLink: React.SFC<TabProps> = props => <Tab type="link" {...props} />

export { TabLink }
